'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;
// import { localStore } from 'utils/localStorage';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _user = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user);

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _analytics = require('redux/modules/analytics');

var analyticsActions = _interopRequireWildcard(_analytics);

var _reactRedux = require('react-redux');

var _components = require('components');

var _ = require('./');

var _support = require('helpers/support');

var _homeSlide = require('assets/img/home/home-slide-1.jpg');

var _homeSlide2 = _interopRequireDefault(_homeSlide);

var _homeSlide3 = require('assets/img/home/home-slide-2.jpg');

var _homeSlide4 = _interopRequireDefault(_homeSlide3);

var _homeSlide5 = require('assets/img/home/home-slide-3.jpg');

var _homeSlide6 = _interopRequireDefault(_homeSlide5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var slides = [_homeSlide2.default, _homeSlide4.default, _homeSlide6.default];

var HomeMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.shops.data,
    banners: state.setup.banners,
    featured: state.shops.featured,
    coords: state.user.coords
  };
}, (0, _extends3.default)({}, shopActions, setupActions, {
  batchHomepage: setupActions.batchHomepage,
  saveUserLocation: userActions.saveUserLocation,
  manualTrack: analyticsActions.manualTrack,
  getAllReward: voucherActions.getAllReward,
  getMyReward: voucherActions.getMyReward
})), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HomeMobile, _Component);

  function HomeMobile(props) {
    (0, _classCallCheck3.default)(this, HomeMobile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HomeMobile.__proto__ || (0, _getPrototypeOf2.default)(HomeMobile)).call(this, props));

    _this.state = {
      offset: {
        promotion: 0,
        homeService: 0,
        nearMe: 0,
        featured: 0,
        suggest: 0,
        collection: 0,
        booking: 0
      },
      showSearch: true,
      headerTitle: 'Lookme',
      random: Math.floor(Math.random() * slides.length)
    };
    _this.timeOut = null;

    _this.onScroll = _this.onScroll.bind(_this);
    _this.getOffset = _this.getOffset.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(HomeMobile, [{
    key: 'getOffset',
    value: function getOffset() {
      var _this2 = this;

      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
      this.timeOut = setTimeout(function () {
        var _refs = _this2.refs,
            promotion = _refs.promotion,
            homeService = _refs.homeService,
            nearMe = _refs.nearMe,
            featured = _refs.featured,
            suggest = _refs.suggest,
            booking = _refs.booking,
            collection = _refs.collection;

        var offset = {
          promotion: _support.Helper.getDistanceTop(promotion && promotion.firstChild),
          homeService: _support.Helper.getDistanceTop(homeService && homeService.firstChild),
          nearMe: _support.Helper.getDistanceTop(nearMe && nearMe.firstChild),
          featured: _support.Helper.getDistanceTop(featured && featured.firstChild),
          suggest: _support.Helper.getDistanceTop(suggest && suggest.firstChild),
          booking: _support.Helper.getDistanceTop(booking && booking.firstChild),
          collection: _support.Helper.getDistanceTop(collection && collection.firstChild)
        };
        _this2.setState({ offset: offset });
      }, 1500);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      window.onScroll = window.addEventListener('scroll', this.onScroll, true);
      this.getOffset();
      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          console.log('position:', position);
          _this3.props.saveUserLocation(position.coords);
          // localStore().set('coords', position.coords);
        });
      }
      this.getBanner();
      this.props.getAllReward({ pageSize: 1000 });
      this.props.getMyReward();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'getBanner',
    value: function getBanner() {
      this.props.loadBanner();
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      var _state$offset = this.state.offset,
          promotion = _state$offset.promotion,
          homeService = _state$offset.homeService,
          nearMe = _state$offset.nearMe,
          featured = _state$offset.featured,
          suggest = _state$offset.suggest,
          booking = _state$offset.booking,
          collection = _state$offset.collection;

      var scrollOffset = window.scrollY;
      var extraOffset = 30;
      if (scrollOffset < 240 && !this.state.showSearch) {
        this.setState({ showSearch: true });
      }
      if (scrollOffset > 240 && this.state.showSearch) {
        this.setState({ showSearch: false });
      }

      if (scrollOffset < promotion) {
        this.setState({ headerTitle: 'Lookme' });
      }
      if (scrollOffset > promotion + extraOffset && promotion > 0) {
        this.setState({ headerTitle: 'Ưu đãi' });
      }
      if (scrollOffset > homeService + extraOffset && homeService > 0) {
        this.setState({ headerTitle: 'Làm đẹp tại nhà' });
      }
      if (scrollOffset > nearMe + extraOffset && nearMe > 0) {
        this.setState({ headerTitle: 'Địa điểm gần bạn' });
      }
      if (scrollOffset > featured + extraOffset && featured > 0) {
        this.setState({ headerTitle: 'Địa điểm nổi bật' });
      }
      if (scrollOffset > collection + extraOffset && collection > 0) {
        this.setState({ headerTitle: 'Bộ sưu tập' });
      }
      if (scrollOffset > suggest + extraOffset && suggest > 0) {
        this.setState({ headerTitle: 'Địa điểm gợi ý' });
      }
      if (scrollOffset > booking + extraOffset && booking > 0) {
        this.setState({ headerTitle: 'Địa điểm đặt lịch' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./HomeMobile.scss');
      var _props = this.props,
          banners = _props.banners,
          history = _props.history;


      var images = [];
      if (banners && banners.length > 0) {
        images = banners.filter(function (item) {
          return item.location === 'top';
        });
        // =======
        //     const images = [];
        //     if (banners && banners.length > 0) {
        //       banners.map(item => {
        //         if (item.location === 'top') {
        //           images.push({
        //             image: item.image,
        //             action: () => this.props.history.push(item.link),
        //           });
        //         }
        //       });
        // >>>>>>> display banner from api
      }
      var showSearch = this.state.showSearch;

      return _react2.default.createElement(
        'div',
        { className: styles.homeMobile + ' demo', style: { width: '100%' } },
        _react2.default.createElement(_reactHelmet2.default, {
          title: 'Home Page',
          meta: [{
            property: 'og:description',
            content: 'Lookme.vn là mạng xã hội địa điểm làm đẹp massage, spa, cắt tóc, phẫu thuật thẩm mỹ, xăm hình,... Nơi chia sẻ và đánh giá địa điểm, với hàng ngàn địa điểm về làm đẹp cùng hàng ngàn bình luận.'
          }, { property: 'og:title', content: 'Home page' }, { property: 'og:image', content: slides[this.state.random] }, { property: 'og:url', content: '' }]
        }),
        !showSearch && _react2.default.createElement(
          'div',
          { className: styles.stickyHeader },
          _react2.default.createElement(_.SearchMobile, { position: 'home' })
        ),
        _react2.default.createElement(
          'div',
          { className: _support.Helper.classNameWebp(styles.mobileSearch, styles.webp) },
          _react2.default.createElement(_components.SwipeBanner, {
            tracking: { screen: 'Home', button: 'Banner' },
            manualTrack: this.props.manualTrack,
            images: images,
            history: this.props.history,
            customImageStyle: styles.itemImage
          }),
          _react2.default.createElement(
            'div',
            { className: styles.searchBox },
            _react2.default.createElement(_.SearchMobile, {
              tracking: { screen: 'Home', button: 'Filter Province' },
              manualTrack: this.props.manualTrack,
              position: 'home'
            })
          )
        ),
        'SearchMobile',
        _react2.default.createElement(_.CategoriesMobile, { manualTrack: this.props.manualTrack }),
        _react2.default.createElement(_.FiveStarPromotion, {
          tracking: { screen: 'Home', section: 'Ưu đãi 5 sao' },
          slogan: 'Trải nghiệm đẳng cấp tại không gian sang trọng',
          manualTrack: this.props.manualTrack,
          history: this.props.history
        }),
        _react2.default.createElement(_.PromotionAtSpa, {
          tracking: { screen: 'Home', section: 'Ưu đãi #trending' },
          manualTrack: this.props.manualTrack,
          history: this.props.history,
          banners: banners,
          title: 'Ưu đãi #trending'
        }),
        _react2.default.createElement(
          'div',
          { ref: 'featured', className: styles.flex },
          _react2.default.createElement(_.FeaturedHomeMobile, {
            tracking: { screen: 'Home', section: 'Địa điểm nổi bật' },
            manualTrack: this.props.manualTrack,
            getOffset: this.getOffset,
            name: '\u0110\u1ECBa \u0111i\u1EC3m n\u1ED5i b\u1EADt',
            slogan: 'Kh\xE1m ph\xE1 \u0111\u1ECBa \u0111i\u1EC3m \u0111\u01B0\u1EE3c xem nhi\u1EC1u tr\xEAn Lookme',
            collection: false,
            banners: banners
          })
        ),
        _react2.default.createElement(_.SectionPersonal, {
          tracking: { screen: 'Home', section: 'Bộ sưu tập' },
          manualTrack: this.props.manualTrack,
          name: 'B\u1ED9 s\u01B0u t\u1EADp'
          // slogan="Thoả sức check–in, đa dạng lựa chọn"
          , getOffset: this.getOffset
        }),
        _react2.default.createElement(
          'div',
          { ref: 'suggest', className: styles.flex },
          _react2.default.createElement(_.SuggestHomeMobile, {
            tracking: { screen: 'Home', section: 'Địa điểm gợi ý' },
            manualTrack: this.props.manualTrack,
            getOffset: this.getOffset,
            name: '\u0110\u1ECBa \u0110i\u1EC3m G\u1EE3i \xDD',
            slogan: 'B\u1EA1n qu\xE1 b\xED? H\xE3y t\u1EDBi \u0111\u1ECBa \u0111i\u1EC3m g\u1EE3i \xFD',
            banners: banners
          })
        ),
        _react2.default.createElement(
          'div',
          { ref: 'booking', className: styles.flex },
          _react2.default.createElement(_.BookingSupportMobile, {
            tracking: { screen: 'Home', section: 'Địa điểm đặt lịch' },
            manualTrack: this.props.manualTrack,
            getOffset: this.getOffset,
            name: '\u0110\u1ECBa \u0110i\u1EC3m \u0110\u1EB7t L\u1ECBch',
            slogan: '\u0110\u1EB7t l\u1ECBch c\u1EF1c k\u1EF3 ti\u1EC7n l\u1EE3i qua Lookme',
            banners: banners
          })
        )
      );
    }
  }]);
  return HomeMobile;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.array,
  banners: _react.PropTypes.array,
  featured: _react.PropTypes.array,
  coords: _react.PropTypes.object,
  prominentLoaded: _react.PropTypes.bool,
  prominentLoading: _react.PropTypes.bool,
  history: _react.PropTypes.object,
  location: _react.PropTypes.object,
  batchHomepage: _react.PropTypes.func,
  saveUserLocation: _react.PropTypes.func,
  loadBanner: _react.PropTypes.func.isRequired,
  manualTrack: _react.PropTypes.func,
  getMyReward: _react.PropTypes.func,
  getAllReward: _react.PropTypes.func
}, _temp)) || _class);
exports.default = HomeMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/HomeMobile.js
// module id = 1602
// module chunks = 0